"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ContactForm } from "@/components/contact/ContactForm";
import { JtPhone } from "@/components/icons/jt-icons";

interface ServiceContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ServiceContactModal({
  isOpen,
  onClose,
}: ServiceContactModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-brand">
            <a
              href="tel:032-858-0508"
              className="flex items-center gap-2 hover:underline"
            >
              <JtPhone className="h-5 w-5" /> 032-858-0508
            </a>
          </DialogTitle>
        </DialogHeader>
        <ContactForm />
      </DialogContent>
    </Dialog>
  );
}
